import React from "react";
import BrandLoader from "../brand/BrandLoader";
import "./style.scss";

function Preloader() {
  return (
    <div className="preload preload-container">
      <BrandLoader size={64} />
    </div>
  );
}

export default Preloader;
